import { RouteComponentProps } from "react-router";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../app/stores/rootStore";
import React, { useContext, useEffect, useState } from "react";
// reactstrap components
import { Row, Col, Button } from "reactstrap";
import classnames from "classnames";
import RepositoryTreeComponent from "../components/repository/RepositoryTreeComponent";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../app/localization/localization";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import GenericModal from "../components/common/GenericModal";
import PresentationForm from "../components/forms/PresentationForm";
import UploadedFileErrors from "../components/common/UploadedFileErrors";
import DiskUser from "../components/common/DiskUser";

const STYLE = `
.rc-tree-child-tree {
  display: block;
}
.node-motion {
  transition: all .3s;
  overflow-y: hidden;
}
`;
const RepositoryUserPage: React.FC<RouteComponentProps> = ({ history }) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const { loadRepository, resetMainRepository, currentRepositoryTree , 
     showErrorFilesUploadedModal, errorsFilesUploaded,
      closeShowErrorFileUploadedModal 
      ,openShowErrorFileUploadedModal, loadDiskSpaceUser , resetDiskSpaceUser,diskSpaceUser} =
    rootStore.presentationStore;
  const { setSourceId } = rootStore.meetingStore;
  const {
    attendingMeeting,
    showPresentationModal,
    openShowPresentationModal,
    closeShowPresentationModal,

  } = rootStore.playerStore;
  const [t] = useTranslation(["features"], translationHookOptions);
  const { isMobileMediaQuery } = rootStore.responsiveStore;
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    loadDiskSpaceUser()
    loadRepository()
      .then((res) => {
        const scrollableElement = document.querySelector(".odgPage");
        if (scrollableElement) disableBodyScroll(scrollableElement);
      })
      .catch();
    return () => {
      resetMainRepository();
      resetDiskSpaceUser();
      const scrollableElement = document.querySelector(".odgPage");
      if (scrollableElement) enableBodyScroll(scrollableElement);
    };
  }, [loadRepository, resetMainRepository]);

  useEffect(() => {
    if (attendingMeeting) setSourceId(attendingMeeting?.id);
    else setSourceId(null);
  }, [attendingMeeting, setSourceId]);

  return (
    <>
      <div className="odgPage">
        <style dangerouslySetInnerHTML={{ __html: STYLE }} />
        <div
          className={classnames(
            "parent",
            `${theme!.titleBarBgOdg} ${theme!.titleBarTextOdg}`
          )}
        >
          <div
            className={classnames(
              isMobileMediaQuery
                ? "odgTitoloRepositoryMobile"
                : "odgTitoloRepository",
              "left margin-right-auto",
              `${theme!.titleBarBgOdg} ${theme!.titleBarTextOdg}`
            )}
          >
            {t("mydocs_page_title_bar")}
          </div>
          <div
            className={classnames(
              isMobileMediaQuery
                ? "odgTitoloRepositoryMobile"
                : "odgTitoloRepository",
              "right",
              `${theme!.titleBarBgOdg} ${theme!.titleBarTextOdg}`
            )}
          >
            <button
              className={classnames(
                isMobileMediaQuery
                  ? "buttonAddPresentationMobile"
                  : "buttonAddPresentation",
                "right",
                "buttonSimple",
              )}
              onClick={() => {
                openShowPresentationModal();
              }}
              style={{ textDecoration: "none", float: "right" }}
              color="link"
            >
              <span className="btn-inner--icon">
                <i className= {classnames("fas fa-plus" , `${theme!.titleBarBgOdg} ${theme!.titleBarTextOdg}`)} />
              </span>
              <span className= {classnames("btn-inner--text" ,`${theme!.titleBarBgOdg} ${theme!.titleBarTextOdg}` )}>
                {" "}
                {t("mydocs_page_add_file")}
              </span>
            </button>
          </div>
        </div>
        {/* 
        <div style={{display:"flex", alignItems:"center"}}>
          <div
           style={{marginRight:"auto"}}
            className={classnames(isMobileMediaQuery ? "odgTitoloMobile" :
            "odgTitolo",
              `${theme!.titleBarBgOdg} ${theme!.titleBarTextOdg}`
            )}
          >
            {t("mydocs_page_title_bar")}
          
            <Button
            onClick={() => {openShowPresentationModal()}}
            style={{textDecoration:"none", float:"right"}}
            color="link">
                <span className="btn-inner--icon">
                  <i className="fas fa-plus text-white bg-dark" />
                </span>
                <span 
                   className={ classnames(isMobileMediaQuery ? "buttonUploadPresentationMobile" :
                "buttonUploadPresentation",
                  `${theme!.titleBarBgOdg} ${theme!.titleBarTextOdg}`, "btn-inner--text ", "text-white bg-dark"
                )}
                // className="btn-inner--text  text-white bg-dark"
                >  {t("mydocs_page_add_file")}</span>
            </Button>
            </div>
        </div> */}
          {diskSpaceUser && (<>
                  <DiskUser  diskspace={diskSpaceUser}></DiskUser>
                 </>)}
        
        <Row>
          <Col xs={12} className="odgContainer">
            {currentRepositoryTree && currentRepositoryTree.tree.length > 0 && (
              <RepositoryTreeComponent
                tree={currentRepositoryTree.tree}
              ></RepositoryTreeComponent>
            )}
          </Col>
        </Row>
      </div>
      <GenericModal
        size="md"
        title={t("mydocs_page_add_file")}
        isOpen={showPresentationModal}
        toggle={() => closeShowPresentationModal()}
        content={<PresentationForm></PresentationForm>}
      ></GenericModal>
        <GenericModal
        size="md"
        title= {t("title_modal_errorsfilesUploaded")}   
        isOpen={showErrorFilesUploadedModal}
        toggle={() => closeShowErrorFileUploadedModal()}
        content={<UploadedFileErrors errorfileUploaded={errorsFilesUploaded}></UploadedFileErrors>}
      ></GenericModal>
    </>
  );
};

export default observer(RepositoryUserPage);
